var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c(_vm.currentLayout,{key:_vm.currentLayout.name,tag:"component",attrs:{"header-options":_vm.headerOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }